import React from "react";

function DataNotFound(data) {
    return (
        <div className="text-center py-5">
            <h1 className="title title--h1">Data Not Found</h1>
        </div>
    );
}

export default DataNotFound;